module.exports = __webpack_public_path__ + "img/560.0c1234a2.jpg";